'use client';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { menu } from '@/routes';
import { Link, usePage } from '@inertiajs/react';

interface HorizontalBadgeScrollProps {
    items: App.Data.CategoryData[] | undefined;
}

export function HorizontalBadgeScroll({
    items = [],
}: HorizontalBadgeScrollProps) {
    const { type, category } = usePage().props.filters as {
        type: string | undefined;
        category: string | undefined;
    };

    if (items.length === 0) return null;

    return (
        <div className="scrollbar-none w-full">
            <div className="scrollbar-hide mt-3 flex items-center gap-2 overflow-x-auto">
                {items.map((item) => {
                    const searchQueryParams = {
                        type: type ?? undefined,
                        category: item.slug ?? undefined,
                    };

                    const isActive = category?.toString() === item.slug;

                    return (
                        <Link
                            key={item.id}
                            href={menu()}
                            data={searchQueryParams}
                            prefetch={true}
                            preserveScroll={true}
                        >
                            <Badge
                                variant={isActive ? 'default' : 'secondary'}
                                className={cn(
                                    'cursor-pointer px-2 py-2 text-xs transition md:text-sm',
                                )}
                            >
                                {item.name}
                            </Badge>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
